import { Firm, Fund } from 'api';
import { FirmListStatus } from 'common/types/firm';
import { MeasurementDate } from 'common/types/measurementDate';
import { ReducerAction, ReducerState } from 'common/types/reducers';

/**
 * @function
 * @name setAllocationCompany
 * @description reducer for action.
 * @param {Object} state  - reducer state
 * @param {Object} action - action context
 * @return {OBJECT} Action context
 */
export const setFirmInfo = (state: ReducerState, action: ReducerAction<{ firmInfo: any }>) => ({
  ...state,
  ...action,
});

export const setFirmInfoById = (state: ReducerState, action: ReducerAction<{ firmState: any }>) => ({
  ...state,
  ...action,
});

export const getFirmList = (
  state: ReducerState,
  action: ReducerAction<{ firms: Firm[]; requires_2fa: boolean; user_has_2fa: boolean; field_attributes: any }>
) => ({
  ...state,
  ...action,
});

export const getUserManagementFirmList = (state: ReducerState, action: ReducerAction<any>) => ({
  ...state,
  ...action,
});

export const getSelectedUserPermissions = (
  state: ReducerState,
  action: ReducerAction<{ selectedUserPermissions: any }>
) => ({
  ...state,
  ...action,
});

export const getFundListByFirmId = (state: ReducerState, action: ReducerAction<{ fundList: Fund[] }>) => ({
  ...state,
  ...action,
});

export const setFirmId = (state: ReducerState, action: ReducerAction<{ firmId: number }>) => ({
  ...state,
  ...action,
});

export const setFirmList = (state: ReducerState, action: ReducerAction<{ firmList: any }>) => ({
  ...state,
  ...action,
});

export const setFirmListStatus = (state: ReducerState, action: ReducerAction<{ firmListStatus: FirmListStatus }>) => ({
  ...state,
  ...action,
});

export const setUserManagementFirmList = (
  state: ReducerState,
  action: ReducerAction<{ userManagementFirmList: Firm[] }>
) => ({
  ...state,
  ...action,
});

export const setSelectedUserPermissions = (
  state: ReducerState,
  action: ReducerAction<{ selectedUserPermissions: any }>
) => ({
  ...state,
  ...action,
});

export const setCurrentMeasurementDate = (
  state: ReducerState,
  action: ReducerAction<{ currentMeasurementDate: MeasurementDate | null }>
) => ({
  ...state,
  ...action,
});

export const setCompanyMeasurementDateList = (
  state: ReducerState,
  action: ReducerAction<{ companyMeasurementDateList: MeasurementDate[] | null }>
) => ({
  ...state,
  ...action,
});
